























import { Component, Vue, Prop } from 'vue-property-decorator';
import fcTransfers from './fcTransfers.json';

interface transfer {
  name: string;
  account: string;
  href: string;
  message: string;
}

@Component
export default class HeaderTransferInfo extends Vue {
  private transfers: object[] = fcTransfers;

  /**
   * handleCommand
   */
  public handleCommand(transfer: transfer): void {
    const link: string = `${transfer.href}/${transfer.account}`;
    this.$message(link);
  }
}
